const API_BASE = process.env.REACT_APP_API_URL_VR_EDITOR;

const fetchWithAuth = async (url, options = {}) => {
    const token = localStorage.getItem("jwt");
    const headers = {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
        ...options.headers,
    };

    const res = await fetch(url, { ...options, headers });
    if (!res.ok) {
        const errorData = await res.json().catch(() => ({}));
        throw new Error(errorData.message || "API request failed");
    }
    return res.json();
};

export const getEvents = () => {
    return fetchWithAuth(`${API_BASE}/events-schedule`);
};

export const deleteEvent = (eventId, pin) => {
    return fetchWithAuth(`${API_BASE}/events-schedule/${eventId}`, {
        method: "DELETE",
        body: JSON.stringify({ pin }),
    });
};

export const joinEvent = (eventId, token) => {
    return fetchWithAuth(`${API_BASE}/events-schedule/${eventId}/join`, {
        method: "POST",
        headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
    });
};

export const leaveEvent = (eventId, token) => {
    return fetchWithAuth(`${API_BASE}/events-schedule/${eventId}/leave`, {
        method: "POST",
        headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
    });
};